import React from "react";
import Bounds from "../InputForm/Bounds/Bounds";

const Step1 = () => {
  return <Bounds />;
};

export default Step1;
